// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfileSideMenu-space1-TOnSO {
	margin-bottom: 6px !important;
}

.EditProfileSideMenu-space2-VXWJR {
	margin-bottom: 12px !important;
}

.EditProfileSideMenu-space3-STXQ7 {
	margin-bottom: 18px !important;
}

.EditProfileSideMenu-space4-OX7Ba {
	margin-bottom: 24px !important;
}

.EditProfileSideMenu-space5-fxa05 {
	margin-bottom: 30px !important;
}

.EditProfileSideMenu-space6-EREZr {
	margin-bottom: 36px !important;
}

.EditProfileSideMenu-space7-VqeeH {
	margin-bottom: 42px !important;
}

.EditProfileSideMenu-spaceTop8-b0_Ig {
	margin-bottom: 48px !important;
}

.EditProfileSideMenu-spaceTop1-txMuG {
	margin-top: 6px !important;
}

.EditProfileSideMenu-spaceTop2-tl6tU {
	margin-top: 12px !important;
}

.EditProfileSideMenu-spaceTop3-RXh36 {
	margin-top: 18px !important;
}

.EditProfileSideMenu-spaceTop4-bkhoj {
	margin-top: 24px !important;
}

.EditProfileSideMenu-spaceTop5-PlwjR {
	margin-top: 30px !important;
}

.EditProfileSideMenu-spaceTop6-MD6aU {
	margin-top: 36px !important;
}

.EditProfileSideMenu-spaceTop7-bCr5g {
	margin-top: 42px !important;
}

.EditProfileSideMenu-spaceTop8-b0_Ig {
	margin-top: 48px !important;
}

.EditProfileSideMenu-noMargin-fyn30 {
	margin: 0px !important;
}

.EditProfileSideMenu-padding1-x9sJa {
	padding-bottom: 6px !important;
}

.EditProfileSideMenu-padding2-rbxSr {
	padding-bottom: 12px !important;
}

.EditProfileSideMenu-padding3-oMPX7 {
	padding-bottom: 18px !important;
}

.EditProfileSideMenu-padding4-y35bQ {
	padding-bottom: 24px !important;
}

.EditProfileSideMenu-padding5-JqNAn {
	padding-bottom: 30px !important;
}

.EditProfileSideMenu-padding6-R3hxT {
	padding-bottom: 36px !important;
}

.EditProfileSideMenu-padding7-O8KF0 {
	padding-bottom: 42px !important;
}

.EditProfileSideMenu-paddingTop1-IyH2v {
	padding-top: 6px !important;
}

.EditProfileSideMenu-paddingTop2-NSGxI {
	padding-top: 12px !important;
}

.EditProfileSideMenu-paddingTop3-gAuu9 {
	padding-top: 18px !important;
}

.EditProfileSideMenu-paddingTop4-qSvHn {
	padding-top: 24px !important;
}

.EditProfileSideMenu-paddingTop5-o5aG2 {
	padding-top: 30px !important;
}

.EditProfileSideMenu-paddingTop6-JqfVn {
	padding-top: 36px !important;
}

.EditProfileSideMenu-paddingTop7-ctvMU {
	padding-top: 42px !important;
}

.EditProfileSideMenu-noPadding-AKk8Z {
	padding: 0px !important;
}

.EditProfileSideMenu-textBold-DerZ6 {
	font-weight: 500 !important;
}

.EditProfileSideMenu-textBolder-MerCy {
	font-weight: 700 !important;
}

.EditProfileSideMenu-textNormal-i2fSP {
	font-weight: normal !important;
}

.EditProfileSideMenu-spaceBottom20-WkrW3 {
	margin-bottom: 20px;
}

.EditProfileSideMenu-spaceBottom10-rP_5b {
	margin-bottom: 10px;
}

.EditProfileSideMenu-marginNone-ozogK {
	margin: 0;
}

.EditProfileSideMenu-spaceBottom15-Djvbs {
	margin-bottom: 15px;
}

.EditProfileSideMenu-marginTopNone-uj1Ui {
	margin-top: 0;
}

.EditProfileSideMenu-spaceTop11-Bl2GI {
	margin-top: 11px;
}

.EditProfileSideMenu-spaceTop21-UX5gp {
	margin-top: 21px;
}

.EditProfileSideMenu-spaceTop20-PsXM8 {
	margin-top: 20px;
}

.EditProfileSideMenu-spaceTop10-frp4E {
	margin-top: 10px;
}

/*New Design Text Colors */

.EditProfileSideMenu-textDarkBlue-eeXwF {
	color: rgb(20, 39, 94) !important;
}

.EditProfileSideMenu-textLightBlue-awfn2 {
	color: rgb(57, 87, 106) !important;
}

.EditProfileSideMenu-textLightSandleGreen-NzXYz {
	color: rgb(76, 86, 41) !important;
}

.EditProfileSideMenu-textLightBrown-iy6NH {
	color: rgb(115, 79, 33) !important;
}

.EditProfileSideMenu-textMediumMaroon-ddTQP {
	color: rgb(87, 37, 51) !important;
}

.EditProfileSideMenu-textBrown-kaVLn {
	color: rgb(160, 47, 24) !important;
}

.EditProfileSideMenu-textMaroon-eubn7 {
	color: rgb(155, 49, 67) !important;
}

.EditProfileSideMenu-textDarkBrown-iVJA3 {
	color: rgb(83, 18, 16) !important;
}

.EditProfileSideMenu-textMediumBrown-Bfl1S {
	color: rgb(142, 28, 10) !important;
}

.EditProfileSideMenu-textSkyBlue-D4LfR {
	color: rgb(37, 117, 141) !important;
}

.EditProfileSideMenu-textGray-OBm2T {
	color: rgb(77, 65, 51) !important;
}

.EditProfileSideMenu-listContainer-HP404 {
	margin: 0px;
	list-style-type: none;
}

.EditProfileSideMenu-sideNavitem-UnqXO {
	display: block;
	padding: 8px 0;
	font-size: 16px;
	color: var(--secondary-foreground);
	text-decoration: none;
}

.EditProfileSideMenu-sideNavitem-UnqXO:hover,
.EditProfileSideMenu-sideNavitem-UnqXO:active,
.EditProfileSideMenu-sideNavitem-UnqXO:focus {
	text-decoration: none;
	color: var(--primary-bg);
}

.EditProfileSideMenu-displayInlineBlock-h9dRb {
	display: inline-block;
}

.EditProfileSideMenu-hoverMenu-AR2oo .EditProfileSideMenu-navitem-T3aN7:hover::before {
	content: '';
	position: absolute;
	width: 5px;
	height: 5px;
	left: 25px;
	background-color: var(--primary-bg);
	border-radius: 50%;
	top: 19px;
}

.EditProfileSideMenu-navitem-T3aN7 {
	position: relative;
}

@media screen and (max-width: 991px) and (min-width: 768px) {
	.EditProfileSideMenu-hoverMenu-AR2oo .EditProfileSideMenu-navitem-T3aN7:hover::before {
		left: 9px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/EditProfileSideMenu/EditProfileSideMenu.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf,kCAAkC;CAClC,qBAAqB;AACtB;;AAEA;;;CAGC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,UAAU;CACV,mCAAmC;CACnC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,SAAS;CACV;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.listContainer {\n\tmargin: 0px;\n\tlist-style-type: none;\n}\n\n.sideNavitem {\n\tdisplay: block;\n\tpadding: 8px 0;\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n}\n\n.sideNavitem:hover,\n.sideNavitem:active,\n.sideNavitem:focus {\n\ttext-decoration: none;\n\tcolor: var(--primary-bg);\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n}\n\n.hoverMenu .navitem:hover::before {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 5px;\n\theight: 5px;\n\tleft: 25px;\n\tbackground-color: var(--primary-bg);\n\tborder-radius: 50%;\n\ttop: 19px;\n}\n\n.navitem {\n\tposition: relative;\n}\n\n@media screen and (max-width: 991px) and (min-width: 768px) {\n\t.hoverMenu .navitem:hover::before {\n\t\tleft: 9px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EditProfileSideMenu-space1-TOnSO`,
	"space2": `EditProfileSideMenu-space2-VXWJR`,
	"space3": `EditProfileSideMenu-space3-STXQ7`,
	"space4": `EditProfileSideMenu-space4-OX7Ba`,
	"space5": `EditProfileSideMenu-space5-fxa05`,
	"space6": `EditProfileSideMenu-space6-EREZr`,
	"space7": `EditProfileSideMenu-space7-VqeeH`,
	"spaceTop8": `EditProfileSideMenu-spaceTop8-b0_Ig`,
	"spaceTop1": `EditProfileSideMenu-spaceTop1-txMuG`,
	"spaceTop2": `EditProfileSideMenu-spaceTop2-tl6tU`,
	"spaceTop3": `EditProfileSideMenu-spaceTop3-RXh36`,
	"spaceTop4": `EditProfileSideMenu-spaceTop4-bkhoj`,
	"spaceTop5": `EditProfileSideMenu-spaceTop5-PlwjR`,
	"spaceTop6": `EditProfileSideMenu-spaceTop6-MD6aU`,
	"spaceTop7": `EditProfileSideMenu-spaceTop7-bCr5g`,
	"noMargin": `EditProfileSideMenu-noMargin-fyn30`,
	"padding1": `EditProfileSideMenu-padding1-x9sJa`,
	"padding2": `EditProfileSideMenu-padding2-rbxSr`,
	"padding3": `EditProfileSideMenu-padding3-oMPX7`,
	"padding4": `EditProfileSideMenu-padding4-y35bQ`,
	"padding5": `EditProfileSideMenu-padding5-JqNAn`,
	"padding6": `EditProfileSideMenu-padding6-R3hxT`,
	"padding7": `EditProfileSideMenu-padding7-O8KF0`,
	"paddingTop1": `EditProfileSideMenu-paddingTop1-IyH2v`,
	"paddingTop2": `EditProfileSideMenu-paddingTop2-NSGxI`,
	"paddingTop3": `EditProfileSideMenu-paddingTop3-gAuu9`,
	"paddingTop4": `EditProfileSideMenu-paddingTop4-qSvHn`,
	"paddingTop5": `EditProfileSideMenu-paddingTop5-o5aG2`,
	"paddingTop6": `EditProfileSideMenu-paddingTop6-JqfVn`,
	"paddingTop7": `EditProfileSideMenu-paddingTop7-ctvMU`,
	"noPadding": `EditProfileSideMenu-noPadding-AKk8Z`,
	"textBold": `EditProfileSideMenu-textBold-DerZ6`,
	"textBolder": `EditProfileSideMenu-textBolder-MerCy`,
	"textNormal": `EditProfileSideMenu-textNormal-i2fSP`,
	"spaceBottom20": `EditProfileSideMenu-spaceBottom20-WkrW3`,
	"spaceBottom10": `EditProfileSideMenu-spaceBottom10-rP_5b`,
	"marginNone": `EditProfileSideMenu-marginNone-ozogK`,
	"spaceBottom15": `EditProfileSideMenu-spaceBottom15-Djvbs`,
	"marginTopNone": `EditProfileSideMenu-marginTopNone-uj1Ui`,
	"spaceTop11": `EditProfileSideMenu-spaceTop11-Bl2GI`,
	"spaceTop21": `EditProfileSideMenu-spaceTop21-UX5gp`,
	"spaceTop20": `EditProfileSideMenu-spaceTop20-PsXM8`,
	"spaceTop10": `EditProfileSideMenu-spaceTop10-frp4E`,
	"textDarkBlue": `EditProfileSideMenu-textDarkBlue-eeXwF`,
	"textLightBlue": `EditProfileSideMenu-textLightBlue-awfn2`,
	"textLightSandleGreen": `EditProfileSideMenu-textLightSandleGreen-NzXYz`,
	"textLightBrown": `EditProfileSideMenu-textLightBrown-iy6NH`,
	"textMediumMaroon": `EditProfileSideMenu-textMediumMaroon-ddTQP`,
	"textBrown": `EditProfileSideMenu-textBrown-kaVLn`,
	"textMaroon": `EditProfileSideMenu-textMaroon-eubn7`,
	"textDarkBrown": `EditProfileSideMenu-textDarkBrown-iVJA3`,
	"textMediumBrown": `EditProfileSideMenu-textMediumBrown-Bfl1S`,
	"textSkyBlue": `EditProfileSideMenu-textSkyBlue-D4LfR`,
	"textGray": `EditProfileSideMenu-textGray-OBm2T`,
	"listContainer": `EditProfileSideMenu-listContainer-HP404`,
	"sideNavitem": `EditProfileSideMenu-sideNavitem-UnqXO`,
	"displayInlineBlock": `EditProfileSideMenu-displayInlineBlock-h9dRb`,
	"hoverMenu": `EditProfileSideMenu-hoverMenu-AR2oo`,
	"navitem": `EditProfileSideMenu-navitem-T3aN7`
};
module.exports = ___CSS_LOADER_EXPORT___;
